import { render, staticRenderFns } from "./UnitStar.vue?vue&type=template&id=a5f6d5fa&"
import script from "./UnitStar.vue?vue&type=script&lang=js&"
export * from "./UnitStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5f6d5fa')) {
      api.createRecord('a5f6d5fa', component.options)
    } else {
      api.reload('a5f6d5fa', component.options)
    }
    module.hot.accept("./UnitStar.vue?vue&type=template&id=a5f6d5fa&", function () {
      api.rerender('a5f6d5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jf0HVIODpNA7/JS/UnitStar.vue"
export default component.exports